import { render, staticRenderFns } from "./showTeam.vue?vue&type=template&id=54faaec0"
import script from "./showTeam.vue?vue&type=script&lang=js"
export * from "./showTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports